import { createFileRoute } from "@tanstack/react-router"
import { SellerLeadDetailsPage } from "@/components/dashboard/admin/pages/external-sellers/SellerLeadDetailsPage"

export const Route = createFileRoute("/external-sellers/$leadId")({
  component: LeadDetailRoute,
})

function LeadDetailRoute() {
  const { leadId } = Route.useParams()
  return <SellerLeadDetailsPage leadId={leadId} />
}
